/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonLwBurnOverviewInfo = {
    PREV_BURN: string;
    PREV_BURN_STATUS: NexonLwBurnOverviewInfo.PREV_BURN_STATUS;
    QTD_BURN_PROJ: string;
    QUARTER_PROG: string;
    TARGET_DT: string;
    TOTAL_BURNED: string;
};

export namespace NexonLwBurnOverviewInfo {

    export enum PREV_BURN_STATUS {
        ACTUAL = 'ACTUAL',
        ESTIMATED = 'ESTIMATED',
    }


}

